/* Ends & Picks — swipeable look cards */
(function () {
  'use strict';
  function init(card) {
    var track = card.querySelector('[data-ep-track]');
    var prev = card.querySelector('[data-ep-prev]');
    var next = card.querySelector('[data-ep-next]');
    var dots = card.querySelectorAll('.ep-look__dots i');
    if (!track || !dots.length || card.hasAttribute('data-ep-ready')) return;
    card.setAttribute('data-ep-ready', '');
    var current = -1;
    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function sync() {
      var i = Math.max(0, Math.min(dots.length - 1, index()));
      if (i === current) return;
      current = i;
      Array.prototype.forEach.call(dots, function (d, n) { d.classList.toggle('is-on', n === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= dots.length - 1;
    }
    track.addEventListener('scroll', sync, { passive: true });
    function go(step) {
      track.scrollTo({ left: (index() + step) * track.clientWidth, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    sync();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-ep-card]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
